import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";
import {
  BooksHeaderLink,
  BooksHeaderWrapper,
} from "../../../Books/components/BooksHeader/BooksHeader.styles";

const UtilitiesHeader: FC = () => {
  const { t } = useTranslation("common");
  return (
    <BooksHeaderWrapper>
      <BooksHeaderLink title={t("sms.tab")} end to="/utilities/sms">
        {t("sms.tab")}
      </BooksHeaderLink>
    </BooksHeaderWrapper>
  );
};

export default memo(UtilitiesHeader);
